const zh = {
  lang: "zh_CN",

  JHPleaseEnter: '请输入{0}',
  JHPleaseSelect: '请选择{0}',
  JHSelect: '选择{0}',
  JHPleaseApply: '请获取{0}',
  JHIllegality: '{0}不合法',
  JHInvalid: '{0}无效',
  JHNotOperated: '{0}未操作',
  JHSendMessage: '发送{0}',
  JHSubmit: '提交{0}',
  JHGetFail: '{0}获取失败',
  JHExecuteError: '{0}执行错误',
  JHFail: '{0}失败',
  JHSuccess: '{0}成功',
  JHStatus: '{0}状态',
  JHDisable: '{0}禁用',
  JHPayment: '{0}支付',
  JHRepeat: '{0}重复',
  JHNotFound: "暂无{0}",
  JHMoreLength: "长度不可超过{0}",
  JHTextDescription: "请填写{0},{1}字以内",
  JHAB: '{0}{1}',
  JHABC: '{0}{1}{2}',
  JHABCD: '{0}{1}{2}{3}',
    JHExisting: '{0}已存在',


  JHNewlyAdd: '新建{0}',

  JHNotExist: '不存在',
  JHMerchant: '商户',
  JHDevice: '设备',
  JHStock: '库存',
  JHSurplus: '剩余',
  JHWarning: '预警',
  JHStream: '流水',
  JHPay: '支付',
  JHAli: '支付宝',
  JHWX: '微信',
  JHUnion: '银联',
  JHUnion1: '银联天满',
  JHJKP: '吉卡云',
  JHSpecial: '特殊',
  JHTogether: '聚合',
  JHBCCB: '建行',
  JHBICBC: '工行',
  JHBEMS: '邮政',
  JHBABC: '农行',
  JHTrade: '交易',

  // 文本内容
  // ERP Add
  JHAdd: '新增',
  JHEdit: '编辑',
  JHDelete: '删除',
  JHRevert: '还原',
  JHQuery: '查询',
  JHSearch: '搜索',
  JHView: "查看",
  JHConfirm: "确定",
  JHCancel: "取消",
  JHClose: "关闭",
  JHArrange: "整理",
  JHNext: "下一步",
  JHPrevious: "上一步",
  JHLink: "关联",
  JHDefault: "默认",
  JHNot: "不",
  JHAuto: "自动",
  JHManual: "手动",
  JHVerify: "审核",
  JHMode: '模式',
  JHRemark: '备注',

  JHAuth: '权限',
  JHSerial: '序号',
  JHCode: '编号',
  JHName: '名称',
  JHSimple: '简写',
  JHDescription: '描述',
  JHOperate: '操作',
  JHPerson: '人',
  JHStore: '店铺',
  JHAddress: '地址',
  JHHeader: '责任人',
  JHData: '数据',
  JHClass: '分类',
  JHType: '种类',
  JHPattern: '类型',
  JHCustom: '自定义',
  JHStrategy: '策略',
  JHKeywords: '关键字',
  JHUnify: '统一',
  JHAlone: '独立',
  JHNo: '单号',
  JHRule: '规则',
  JHPrefix: '前缀',
  JHSuffix: '后缀',
  JHTime: '时间',
  JHFormatter: '格式',
  JHLength: '长度',
  JHNum: '数值',
  JHGrater: '大于',
  JHLess: '小于',
  JHEqual: '等于',
  JHForm: '表单',
  JHYear: '年',
  JHMonth: '月',
  JHDay: '日',
  JHWeek: '周',
  JHHour: '时',
  JHMinute: '分',
  JHSecond: '秒',
  JHMillisecond: '毫秒',
  JHTimeStamp: '时间戳',
  JHAnd1: '并',
  JHAnd2: '和',
  JHBatch: '批量',
  JHForever: '永久',
  JHReason: '原因',
  JHFunction: '功能',
  JHOriginal: '原始',
  JHLog: '日志',
  JHError: "错误",
  JHActual: "实时",
  JHCredit: "结余",
  JHUpper: "上限",
  JHLower: "下限",
  JHLastC: "上次",
  JHThisC: "本次",
  JHNextC: "下次",


  // ERP Part
  JHPLUCenter: '商品库',
  JHArea: '区域',
  JHDepot: '仓库',
  JHInfo: '信息',
  JHContent: '内容',
  JHNote: '票据',
  JHList: '列表',
  JHPurchase: '采购',
  JHUse: '领用',
  JHAllot: '调拨',
  JHEnter: '录入',
  JHSale: '销售',
  JHStockIn: '进货',
  JHRefundOut: '退货',
  JHPutIn: '入库',
  JHPutOut: '出库',
  JHOther: '其他',
  JHInventory: '盘库',
  JHOrderPlan: '订货',
  JHProfitLoss: '损溢',
  JHLoss: '损',
  JHProfitBill: '溢',
  JHUnconfirmed: "未确认",
  JHClean: "清除",
  JHPutUp: "挂单",
  JHDetail: '明细',
  JHAmount: '数量',
  JHStaging: '暂存中',
  JHSaved: '已保存',
  JHWaitVerify: '待审核',
  JHVoided: '已作废',
  JHClosed: '已关闭',
  JHFinish: '已完结',
  JHReviewed: '已反审',
  JHHedged: '已对冲',
  JHUnKnow: "未知",
  JHLoad: "加载",
  JHLoading: "加载中",
  JHPLUName: "品名",
  JHUnit: "单位",
  JHAmountWeight: "数/重量",
  JHSubTotal: "小计",
  JHQR: '二维码',
  JHStage: '暂存',
  JHSave: '保存',
  JHRevoke: '撤销',
  JHReview: '反审',
  JHHedge: '对冲',
  JHRepeal: '作废',
  JHRestore: '恢复',
  JHReturn: '返回',
  JHSupplier: "供应商",
  JHFirst: '首次',
  JHCreate: '创建',
  JHPLU: '商品',
  JHLibrary: '库',
  JHWeighting: "计重",
  JHByThePiece: "计件",
  JHPCSing: "件",
  JHPurchasePrice: "进价",
  JHPrice: "单价",
  JHMoney: "金额",
  JHSummary: "汇总",
  JHSettle: "结算",
  JHDetails: "详情",
  JHCounter: "计数",
  JHConfig: "配置",
  JHSetting: "设置",
  JHDaySettle: "日结",
  JHWeekSettle: "周结",
  JHMonthSettle: "月结",
  JHYearSettle: "年结",
  JHSingle: "单品",
  JHInit: "初始",
  JHNormal: "正常",
  JHBurden: "负",
  JHZero: "零",
  JHTobeSettled: "待结算",
  JHSettled: "已结算",
  JHDocument: "单据",
  JHBRScale: "条码收银秤",
  JHPOSScale: "POS收银秤",
  JHBTScale: "POS收银秤",
  JHTKScale: "汽车衡",
  JHProductsSummery: '单品汇总',
  JHClassSummery: '分类汇总',
  JHWareHouseSummery: '仓库汇总',
  JHProfit: '毛利润',
  JHProfitTips: '毛利润 = 出库总金额(反数) - 出库总成本',
  JHGross: '毛利率',
  JHGrossTips:'毛利率 = 出库总金额 == 0? (入库总金额 == 0 ? 0 : (利润 / 入库总金额)) : (利润 / 出库总金)',
  JHRefer: '参考',

  JHExperience:'经历',
  JHWriteIn:'写入',
  JHPhysics:'物理',
  JHLogic:'逻辑',
  JHRecovery:'恢复',

  JHOneToMultiple:'一品多销',
  JHRatio:'比例',
  JHSalePlu:'销品',
  JHMaterial:'原料',
  JHGroupPlu:'组合商品',
  JHFormula:'配方',
  JHProduct:'产品',
  JHMachining:'加工',
  JHCost:'成本',
  JHDescribe:'描述',
  JHRepeatFormula:'该配方已存在，请重试',

  // 文本内容 JKY
  JHPhonePayWarning: "商家允许用户使用手机号储值扣款，用户默认开通此项功能；",
  // 文本内容 ERP
  JHAreaDescription1: "针对仓库实现分区功能以及汇总清算，非特定需求用户无需添加分区",
  JHDepotDescription1: "库存结算汇总维度，非特定用户使用默认仓库即可",
  JHDepotDescription2: "若关联了店铺，店铺生成的销售退货等库存信息，将自动关联到此店铺默认仓库下；若未关联店铺，商户生成的销售退货等库存信息，将自动关联到商户默认仓库下",
  JHDepotDescription3: "请选择店铺,不关联默认全局仓库",
  JHDepotDescription4: "将该仓库设置成商户/店铺下的默认库存，销售退货库存自动关联到该仓库",
  JHDepotDescription7: "变更默认设置，可能影响实时库存汇总，是否确认此操作",
  JHDepotDescription8: "存在默认配置并未强制设置",
  JHDepotDescription9: "不存在默认配置并未强制设置",
  JHDepotDescription10: "变更关联店铺，可能影响实时库存汇总，是否确认此操作",
  JHDepotDescription11: "关联区域信息，有必要商户可根据区域实行数据汇总",

  JHNoteDescription1: '针对票据实现分组功能，非特定需求用户无需添加，系统在票据种类创建时回自动创建默认分类',
  JHNoteDescription2: '商户具体支持票据业务，从系统中支持的票据策略中选择需要添加的票据策略',
  JHNoteDescription3: '请从系统中支持的票据策略中选择所需的策略，若未找到所需，请联系经销商，让进销商反馈',
  JHNoteDescription4: '统一策略：票据单号使用统一规则获取；独立策略：票据单号使用配置的独立策略。',
  JHNoteDescription5: '当前票据序号规则顺序值',
  JHNoteDescription6: '年月日（210821）|年月（2108）|时间戳1（秒）|时间戳2（毫秒）',
  JHNoteDescription7: '票据创建成功后是否自动审核，自动审核票据直接操作库存，审核票据需要用户审核通过后操作库存',
  JHNoteDescription8: '根据规则自动审核（不重复），可自定义修改(暂不支持)',
  JHNoteDescription9: '票据备注定义',
  JHNoteDescription10: '单据供应商，可不填',
  JHNoteDescription11: '根据需求选择需要操作的仓库',
  JHNoteDescription12: '商品库：商品库选择批量添加(推荐)；数量：预创建行数列表中添加',
  JHNoteDescription13: '添加空行数量，用于填充票据明细（0 < n <= 50）',
  JHNoteDescription14: '单击：选择仓库新增',
  JHNoteDescription15: '双击：取消选择的仓库',
  JHNoteDescription16: '检查，整理并剔除无效的票据明细',

  JHStockDescription1: '商户待结算、已结算的库存流水',
  JHStockDescription2: '店铺待结算、已结算的库存流水',
  JHStockDescription11: '区域待结算、已结算的库存流水',
  JHStockDescription3: '仓库待结算、已结算的库存流水',
  JHStockDescription4: '商品待结算、已结算的库存流水，俗称："单品进销存"',
  JHStockDescription5: '单击：选择单品查询',
  JHStockDescription6: '双击：重置单品选择',
  JHStockDescription7: '商户库存状态信息',
  JHStockDescription8: '店铺库存状态信息',
  JHStockDescription9: '仓库库存状态信息',
  JHStockDescription10: '库存=实时库存+结余库存',

  JHSettleDescription1: '查询商户所有仓库并汇总结算所有仓库实时库存信息',
  JHSettleDescription2: '自动结算类型',
  JHSettleDescription3: '结算期间确保不会再有交易发生，请务必确保交易处于停止状态再结算，若中间过程存在交易导致结算数据出现差异账目不对商户自行承担后果！！！',
  JHSettleDescription4: '查询店铺所有仓库并汇总结算所有关联仓库实时库存信息',
  JHSettleDescription5: '查询区域所有仓库并汇总结算所有关联仓库实时库存信息',
  JHSettleDescription6: '查询仓库并汇总结算仓库实时库存信息',

  JHSystemCreateDefault: "默认使用系统生成，可自定义",

  JHDBError1: "数据库更新失败",
  JHDataError1: "数据无效",

  JHFormulaOverwriteTips: '您所添加的商品已有如下配方，确认覆盖吗？',
  JHLevelTips: '用于划分不同等级，等级关联店铺，修改多个店铺商品价格可根据等级修改',



  JHRecycle: "回收",
  JHFile: "文件",
  JHMerge: "合并",
  JHTakeEffect: "生效",
  JHReset: "重置",
  JHCover: "覆盖",
  JHCurrent: "当前",
  JHCloudServices: "云端",
  JHAssistant: "营业员",
  JHShortcutPage: "快捷页",
  JHHotKey: "快捷键",
  JHModel: "模型",
  JHTrain: "训练",
  JHHandle: "处理",
  JHVersion: "版本",
  JHUpgrade: "升级",
  JHHistory: "历史",
  JHSelected: "已选择",
  JHPicture: "图片",
  JHPlatform: "平台",
  JHTips: "提示",
  JHUser: "用户",
  JHSelectAll: "全选",
  JHEmpty: "空",
  JHAvatar: "头像",
  JHIssued: "下发",
  JHParent: "父级",
  JHBarcode: "条码",
  JHOffTheShelf: "下架",
  JHShelf: "上架",
  JHStopSelling: "停售",
  JHOutOfStock: "缺货",
  JHArchives: "档案",
  JHArticleNumber: "货号",
  JHQuantifier: "量词",
  JHSaveAsWeight: "保存为重量",
  JHTare: "皮重",
  JHPercentage: "百分比",
  JHWeight: "重量",
  JHTaxRate: "税率",
  JHPrint: "打印",
  JHSign: "标志",
  JHBitmap: "位图",
  JHDate: "日期",
  JHInteger: "整数",
  JHPackage: "包装",
  JHUsed: "使用",
  JHText: "文本",
  JHManualDiscount: "手动折扣",
  JHAutoDiscount: "自动折扣",
  JHActivationDate: "激活日",
  JHRange: "区间",
  JHNotUsed: "未使用",
  JHTaxAmount: "税额",
  JHBasic: "基本",
  JHGrade: "等级",
  JHInput: '输入',
  JHGeneral: '普通',
  JHTimeSpan: '时段',
  JHSingleCalculation: "单计",
  JHForbidSale: "禁售",
  JHMember: "会员",
  JHSystem: "系统",
  JHNoTax: "无税",
  JHExtraPriceTax: "价外税",
  JHInPriceTax: "价内税",
  JHAfterTaxPrice: "税后价",
  JHAs: "为",
  // JHSunday: "星期日",
  // JHMonday: "星期一",
  // JHTuesday: "星期二",
  // JHWednesday: "星期三",
  // JHThursday: "星期四",
  // JHFriday: "星期五",
  // JHSaturday: "星期六",
  JHImport: "导入",
  JHDeDuplication: "去重",
  JHDeDuplicationTips: "根据商品名去重(优先保留价格高的,创建时间新的)",
  JHPriceChange: "改价",
  JHFast: "快速",
  JHDoubleClick: "双击",
  JHDecompose: "分解",
  JHAssemble: "组装",
  JHReversible: "可逆",
  JHRenew: "更新",
  JHTel: "电话",
  JHCostsSalculateTips: "是否根据比例重新计算成本",
  JHPerfect: "完善",
  JHTemplate: "模板",
  JHRentOut: "出租",
  JHMarket: "市场",
  JHEarlyWarning: "预警",
  JHRefuse: "拒绝",
  JHRenting: "退租",
  JHUnbinding: "解绑",
  JHYes: "是",
  JHNoNo: "否",
  JHBusinessLicense: "营业执照",
  JHHealthCertificate: "健康证",
  JHIDCard: "身份证",
  JHHygieneLicense: "卫生许可证",
  JHInspection: "巡检",
  JHRecords: "记录",
  JHCopy: "复制",
  JHAllocation: "分配",
  JHCharacterSet: "字符集",
  JHOnline: "在线",
  JHOffline: "离线",
  JHBeBusy: "忙碌",
  JHPeriodOfValidity: "有效期",
  JHEquipment: "器材",
  JHExpire: "过期",
  JHAbnormal: "异常",
  JHIncomplete: "未完成",
  JHProject: "项目",
  JHMore: "更多",
  JHPickUp: "收起",
  JHAsync: "同步",
  JHSort: "排序",
  JHTag: "标签",
  JHQualifications: "资质",
  JHBlurb: "简介",
  JHAlias: "别名",
  JHLegalPerson: "法人",
  JHOrigin: "源产地",
  JHPlantation: "种植园",
  JHSlaughterhouse: "屠宰场",
  JHEvery: "每",
  JHSunday: '周日',
  JHMonday: '周一',
  JHTuesday: '周二',
  JHWednesday: '周三',
  JHThursday: '周四',
  JHFriday: '周五',
  JHSaturday: '周六',
  JHStatistics: "统计",
  JHAverage: "平均",
  JHTheSame: "相同",
  JHCreateFileSlowTips: "生成文件较慢,是否继续等待",

  JHImportPLUTips1: "如果存在相同编号会覆盖原有数据（如果被覆盖数据有未出现在表格中的信息回被覆盖），不能使用特殊符号",
  JHImportPLUTips2: "如需修改文件名请在模板文件名后追加",
  JHImportPLUTips3: "文件大小超过 1M 需要拆分成多个文件分批上传",
  JHEntityCard: "实体卡",
  JHExample: "示例",
  JHStepNum: "步长",



  JHComplete: "{0}完成",
  JHAlready: "已{0}",
  JHBaseON: "以{0}为准",
  JHUsingAs: "以{0}为{1}",
  JHTimeOut: "{0}超时",
  JHFixed: "固定{0}",
  JHWithin: "{0}内",
  JHWithout: "{0}外",
  JHNotHave: "无{0}",
  JHTheStep: "第{0}步",
  JHWhether: "是否{0}",


  // 我的
  JHLogReport: "日志报表",
  JHNumberOfTransactions: "笔数",
  JHRefund: "退款",
  JHRefundTips: "退款后现金支付部分将退入会员卡储值余额中",
  JHAmountAfterDiscount: "折后金额",
  JHRoundedAmount: "折舍金额",
  JHCardPayment: "卡付",
  JHGikayun: "吉卡云",
  JHCloudPay: "云支付",
  JHReport: "报表",
  JHCloudFlashPayment: "云闪付",
  JHLongPayment: "龙支付",
  JHOrder: "订单",
  JHPayThrough: "收付通",

  // JKY
  JHRecharge: '充值',
  JHConsume: '消费',
  JHIntegral: '积分',
  JHAccumulate: '累计',
  JHDiscount: '折扣',
  JHSpecialOffer: '特价',
  JHCash: '现金',
  JHScene: '现场',
  JHGroup: '组合',
  JHMobile: '手机',
  JHPaymentLimit: '限额',
  JHUserName: '用户名',
  JHBalance: '储值',
  JHGive: '赠送',
  JHBalances: '余额',
  JHMobileBalance: '手机号储值',

  // ZXD
  JHVideo: '视频',
  JHStall: '摊位',
  JHStallNo: '摊位号',
  JHExchange: '更换',
  JHBoothNo: "摊位号",
  JHContacts: "联系人",
  JHTotalNumber: "总数",
  JHMainBusiness: "主营",
  JHClear: "清空",
  JHReplace: "替换",
  JHRandom: "随机",
  JHAutoBatchAllocat: "随机批量自动分配",
  JHRandomAllocaOfDS: "指定摊位随机分配",
  JHDesReplace: "1V1指定摊位更换",
  JHAll: "全部",
  JHToBeAllocated: "待分配",
  JHNoPermission: "暂无权限",
  JHAtLeast: "最少",
  JHStart: "开始",
  JHEnd: "结束",
  JHApply: "申请",
  JHDownload: "下载",
  JHUpload: '上传',
  JHAnalysis: '解析',
  JHAutoInspectionDesp: "自动创建表示次日统一由系统创建状态为未完成的巡检记录",
  JHInspectionTimeTips: "固定间隔巡检,间隔时长不能大于15天",
  JHFireFighting: '消防',
  JHNHealth: "卫生",
  JHNRubbish: "垃圾",
  JHNLooks: "容貌",
  JHInterval: '间隔',


  JHToBe: '待{0}',
  JHExport: '导出{0}',
  JHReload: '刷新{0}',
  JHInProcessOf: '正在{0}',



  JHManage: '{0}管理',
  JHServiceCharge: '服务费',
  JHCommand: '命令',
  JHCommissionSharing: '分佣',
  JHWithdrawal: '提现',
  JHDistributor: '经销商',
  JHAuthCode: '授权码',
  JHTruename: '真实姓名',
  JHBatchNumber: '批次号',
  JHPublicPraise: '口碑',
  JHFMCG: '快消',
  JHBinding: '绑定',
  JHUnbound: '未绑定',
  JHDevice30DayTips: '设备已绑定超30天,不允许解绑',
  JHOr: '或',
  JHVerificationCode: '验证码',
  JHInstructionsForUse: '使用说明',
  JHUnbindingTips1: '本解绑只支持未开通云支付的设备解绑，若开通云支付，请联系商户解绑',
  JHUnbindingTips2: '若需解绑设备，必须保证解绑人可以操作设备，否则无法执行操作步骤',
  JHUnbindingTips3: ' 输入设备Mac，发送验证码；若提示设备未离线，编程44，快速编程+修正',
  JHUnbindingTips4: '云支付显示横线后，重新点击"发送验证码"',
  JHUnbindingTips5: '根据成功返回的提示信息，编程44，快速编程 + 修正，再修正，根据打印小票查看',
  JHUnbindingTips6: '“解绑-经销商手机号码 ： 验证码”',
  JHUnbindingTips7: '查看6位数验证码，输入至验证码处，进行设备解绑，根据返回信息查看解绑状态',
  JHUnbindingTips8: '并重新修正查看是否出现重新绑定的二维码。',
  JHOperator: '操作人',
  JHCompany: '公司',
  JHEmail: '邮箱',
  JHCustomerService: '客服',
  JHWithdrawable: '可提现',
  JHToBeCredited: '待入账',
  JHInvoice: '发票',
  JHBill: '账单',
  JHDimension: '维度',
  JHCashierScale: '收银秤',
  JHHangingScale: '吊秤',
  JHBluetooth: '蓝牙',
  JHThirdParty: '第三方',
  JHMonitor: '显示屏',
  JHSelfService: '自助',
  JHRate: '费率',
  JHOfficialAccount: '公众号',
  JHChannel: '渠道',
  JHChannelChangeTips: '此策略的更改将影响用户的支付渠道，请勿随意更改',
  JHChannelChangeTips2: '此操作将更改用户的支付渠道, 请谨慎操作',
  JHTerminal: '终端',
  JHCounterBar: '柜台',
  JHAuthentication: '认证',
  JHTotal: '总{0}',
  JHShenyang: '沈阳',
  JHShanghai: '上海',
  JHActivation: '激活',
  JHTest: '测试',
  JHSecretKey: '秘钥',
  JHPublicKey: '公钥',
  JHPrivateKey: '私钥',
  JHCertificate: '证书',
  JHBranch: '分行',
  JHAccount: '账号',
  JHPassword: '密码',
  JHGroupNumber: '集团号',
  JHCustomerNo: '客户号',
  JHSignature: '签名',
  JHWay: '方式',
  JHTokenURL: '回调地址',
  JHAPP: '应用',
  JHPaymentCode: '付款码',
  JHRateTips1: '银联费率可点击云支付费率按钮进行修改',
  JHRateTips2: '成本2.0‰,利润1.8‰,经销商50%（0.9‰）,精函50%（9‰）',
  JHRateTips3: '成本2.0‰,利润1.2‰,经销商50%（0.6‰）,精函50%（6‰）',
  JHRateTips4: '成本2.0‰,利润1.0‰,经销商50%（0.5‰）,精函50%（5‰）',
  JHRateTips5: '成本2.0‰,利润0.9‰,经销商50%（0.45‰）,精函50%（4.5‰）',
  JHRateTips6: '成本2.0‰,利润0.8‰,经销商50%（0.4‰）,精函50%（4‰）',
  JHRateTips7: '成本2.0‰,利润0.7‰,经销商46%（0.322‰）,精函54%（3.78‰）',
  JHRateTips8: '成本2.0‰,利润0.6‰,经销商43%（0.258‰）,精函57%（3.42‰）',
  JHRateTips9: '成本2.0‰,利润0.5‰,经销商40%（0.2‰）,精函60%（3‰）',

  JHCCBRateTip1: "利润1.8‰,经销商50%（0.9‰）,精函50%（0.9‰）",
  JHCCBRateTip2: "利润1.2‰,经销商50%（0.6‰）,精函50%（0.6‰）",
  JHCCBRateTip3: "利润1.0‰,经销商50%（0.5‰）,精函50%（0.5‰）",
  JHCCBRateTip4: "利润0.9‰,经销商50%（0.45‰）,精函50%（0.45‰）",
  JHCCBRateTip5: "利润0.8‰,经销商50%（0.4‰）,精函50%（0.4‰）",
  JHCCBRateTip6: "利润0.7‰,经销商46%（0.322‰）,精函54%（0.378‰）",
  JHCCBRateTip7: "利润0.6‰,经销商43%（0.258‰）,精函57%（0.342‰）",
  JHCCBRateTip8: "利润0.5‰,经销商40%（0.2）,精函60%（0.3‰）",
  JHRateAddTips: "暂未查询到银联支付费率,是否前往新增",
  JHLoginTips1: '欢迎登录 经销商 平台',
  JHLoginTips2: '请使用本人账号密码登录',
  JHLoginTips3: '还没有账号？去注册',
  JHLoginTips4: '经销商管理平台',
  JHForgetPWD: '忘记密码',
  JHRememberPWD: '记住密码',
  JHLogin: '登录',
  JHLogout: '退出登录',
  JHObtain: '获取',
  JHCountry: '国家',
  JHNewPassword: '新密码',
  JHNewPasswordTips: '两次密码不相同，请重新确认',
  JHRegister: '注册',
  JHWithdrawalTips: '申请提现金额不可大于可提现金额',
  JHSigning: '签约',
  JHResult: '结果',
  JHOperation: '经营',
  JHFrontalView: '正面照',
  JHReverseView: '反面照',
  JHIDNo: '身份证号码',
  JHIndividualBusiness: '个体工商户',
  JHAbbreviation: '简称',
  JHPhoto: '照片',
  JHShopSign: '招牌',
  JHIndoorScene: '内景',
  JHEstablishAnAccount: '开户',
  JHBankCard: '银行卡',
  JHBank: '银行',
  JHFullName: '全称',
  JHProvincialCityCode: '省市编码',
  JHComparisonTable: '对照表',
  JHBusinessScenario: '经营场景',
  JHSelfTest: '自检',
  JHSaveSubmitThirdParty: '保存并提交第三方审核',
  JHRateTips10: '该商户已有云支付费率配置，是否使用已配置的费率?',
  JHEnterprise: '企业',
  JHParameter: '参数',

  JHLeadSealManage:'铅封管理',
  JHLeadSealManageEdit:'铅封信息完善',
  JHDeviceMac:'设备序号',
  JHSealCode:'铅封序号',
  JHLeadSealStatus:'铅封状态',
  JHUnpacked:'未铅封',
  JHSealedLead:'已铅封',
  JHUnlocked:'已解封',
  JHApproved:'已审计',
  JHReviewFailed:'审计失败',
  JHOperatorType:'操作人类型',
  JHFactory:'工厂',
  JHFac:'厂',
  JHLeadSeal:'铅封',
  JHLeadSealingAndUnsealing:'铅封与解封',
  JHBeforeOperation:'操作前',
    JHAfterOperation:'操作后',
    JHPhotograph:'拍照',
    JHRetake:'重拍',
  JHAppNo:'应用序号',
  JHDeviceType:'设备类型',
  JHService:'维修',
  JHCalibration:'标定',
  JHPleaseUploadPictures:'请上传图片',
    JHStandard:'标准',
    JHImageUploadMethod:'图片上传方式',
    JHUploadMethod:'上传方式',
    JHLocalImg:'本地图片',
    JHIsOpenCamera:'正在打开摄像头，请稍候...',
    JHNoCamera:'暂无可用摄像头，请检查硬件设备...',
    JHCamera:'摄像头',
    JHPleaseUploadDevicePictures:'请上传设备图片',
    JHPleaseUploadSealPictures:'请上传铅封图片',
  JHNameplate:'铭牌',
  JHFuBei:'付呗',
  JHShouQianBa:'收钱吧',
  JHSaoBei:'扫呗',
  JHAlreadyRealName:'已实名',

  ChangePassword:'修改密码',
  PleaseEnterThePasswordAgain:'请再次输入密码',
  JHPasswordFormatRequirements:'密码格式要求：密码长度≥12 位，由大小写字母、数字以及特殊字符组成，同时禁止连续重复字符',
  PasswordNotSpecifications:'密码不符合规范',
  PEnterNewPwd:'请输入新密码',
  PwdNotGoodPEnter:'密码不符合要求，请重新输入',
  remindEditPwdTips:'您的密码已超过90天未修改，为了您的账户安全，请修改密码',
  toEditPwd:'去修改密码',
  noReminder30:'30天内不提醒',


};
export default zh;



// WEBPACK FOOTER //
// ./src/i18n/zh.js